import axios from 'axios'

if (JSON.parse(localStorage.getItem('authentication')) != undefined) {
  var token_acesso = 'token ' + JSON.parse(localStorage.getItem('authentication')).token_autenticado
} else {
  var token_acesso = 'token '
}

export const apiBlog = axios.create({
  baseURL: 'https://blog.innovationbrindes.com.br/api/',
  // baseURL: 'http://localhost:3000/api/',
})

export async function runVerificaAutenticacao() {
  const response = await verificaAutenticacao.get()
  var dados = response.data

  return dados
}

export const baseURL = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2',
  headers: {
    Authorization: token_acesso,
    'Content-Type': 'application/json',
  },
})

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
})

export const BuscaTodosProdutosDev = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/busca/busca-todos-produtos-dev',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListarInfoLayoutProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/listar-informacoes-produto-layout',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaTerminoLayout = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-finalizacao-layout',
})

export const AtualizaInicioLayout = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-inicio-layout',
  headers: {
    Authorization: token_acesso,
    'Content-Type': 'application/json',
  },
})
export const listarDevolucoes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/categoria/listar-devolucoes/',
  headers: {
    Authorization: token_acesso,
    'Content-Type': 'application/json',
  },
})

export const verificaAutenticacao = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/verifica/verifica-autenticacao',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasestado = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-estado',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendavendedor = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-consultor/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const listagemVendedores = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const dashboardHome = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/home/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DadosUsuarioHome = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/home/dados-usuario-logado',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const relatorioOrigem = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-estado-origem/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasPorEmpresa = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-cliente/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasAnual = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-mes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasAnualDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-mes-detalhes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const chamadosConsultor = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-por-consultor/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const chamadosAbertos = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-abertos/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const chamadosConsultorAnalitico = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-por-consultor-analitico/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const pendenciasDoDia = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-pendentes-dia',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const pendenciasDoDiaTMK = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-pendentes-dia-tmk',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const propostasDeConfeccoes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-confeccoes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const pendenciasAtrasadas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-pendentes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const pendenciasAtrasadasTMK = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-pendentes-tmk',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const novosChamados = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-novos',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const propostasImportantes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-importantes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const propostasNaoEnviadas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-nao-enviados',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const clientesImportantes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-clientes-importantes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const propostasDeConfeccoesNaoRespondidas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-confeccoes-nao-respondidas',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasCidade = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-cidade',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const propostasPerdidas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-perdidos',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasConsultorDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-consultor-detalhes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasEmpresaDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-cliente-detalhes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const vendasCidadeDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendas/listar-por-cidade-detalhes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const chamadosAbertosDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-abertos-total/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const chamadosConsultorAnaliticoDetalhes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-por-consultor-analitico-detalhes/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const acompanhamentoDePropostas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-acompanhados/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const acessarSistema = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/login/acessar',
  headers: {
    'Content-type': 'application/json',
  },
})

export const ListaDadosProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-dados-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaItensPropostas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-itens-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaClientes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-clientes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaContato = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-contatos-por-parceiro',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaCondicaoPagamento = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-condicao-pagamento',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaTotalOrcamentoPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-total-orcamentos-pedidos',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaConfigProdutos = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaConfigEmbalagem = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/listar-configuracao-embalagem',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaProdutos = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/listar-por-subcategoria/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const buscaProdutoPorParametros = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/busca',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const buscaMelhorOfertaProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/produto-melhor-oferta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const buscaInfoProdSelecionado = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-infos-para-add-item-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const buscaValorProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/buscar-valor-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const inserirDadosProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/inserir-dados-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const listaTransportadora = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-transportadora',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const listaTipoTransportadora = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-tipo-transportadora',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaFunilDeVenda = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-funil-de-venda',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaHistorico = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-dados-historico-tmk',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaEmpresas = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-empresas',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaStatusPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/lista-status-pedido',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaImpressoes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/lista-impressoes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaStatusPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/atualiza-status-pedido/',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaVendedoresAtivos = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-ativos',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaProdutividadeDetalhada = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-produtividade',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaProdutividadeDetalhadaDashboard = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/dashboard-listar-produtividade-anual',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaRankingMes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-ranking-mes-vendedores',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListaRankingMesSelect = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-ranking-mesensal-vendas',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaVendasClientes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-vendas-por-clientes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaRankingAnual = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/vendedor/listar-ranking-anual-vendedores',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaDiretorioImagensProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/config-site/lista-diretorio-imagens-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const SalvarDiretorioImagensProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/config-site/salvar-imagens-no-diretorio',
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'PUT, POST, DELETE, GET, OPTIONS',
    'Access-Control-Allow-Headers': 'Accept, Authorization, Content-Type',
    Authorization: token_acesso,
  },
})
export const SalvarImagensFinanceiro = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/config-site/salvar-boleto-empresa',
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'PUT, POST, DELETE, GET, OPTIONS',
    'Access-Control-Allow-Headers': 'Accept, Authorization, Content-Type',
    Authorization: token_acesso,
  },
})

export const ListaEstimativaValor = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/chamado/listar-estimativa-valor',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaTelasCRM = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/login/lista-telas',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaPerguntasFrequentes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/faq/listar-perguntas',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaResumoProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-resumo-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaItensResumoProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-itens-resumo-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaDespesasExtraResumoProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-despesas-extra-resumo-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const InserirDespesasExtrasProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/inserir-despesa-extra-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const InserirHistoricoTMK = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/inserir-historico-tmk',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaMotivoPerda = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/lista-motivos-perda',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaCubagemProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto/listar-cubagem',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaInfoPNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/listar-info-p-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const AtualizaInfoPNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/atualiza-info-p-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListarInformacoesTelaInfoPNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/categoria/listar-informacoes-tela-info-p-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListarInfoPosNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/categoria/listar-informacoes-pos-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const AtualizaPendenciaNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-pendencia-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListarProsUpdateNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/listar-pos-update-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const AtualizaPendenciaPosNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-pendencia-pos-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListaCubagemPorCaixa = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/lista-cubagem-do-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaCubagemPorCaixa = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/atualiza-cubagem-do-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const InserirFreteProposta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/inserir-frete-proposta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const dadosParceiro = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cliente/busca-dados-parceiro',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DeletarEmbalagemProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/deleta-embalagem-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DeletarProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/deleta-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DadosProdutosDestaque = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/deleta-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaTabelaPrecoEmbalagem = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const EnviarPropostaParaCliente = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cadastro/enviar-proposta-cliente',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaDadosPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/atualiza-dados-pedido',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaQuantidadeProdutoPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/atualiza-quantidade-produto-pedido',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const UploadFileDrive = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/google/upload-arquivo-drive',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaLayoutProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/orcamento/lista-layout-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaConfirmaEstoque = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/lista-produtos-para-confirmacao-de-estoque',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ConfirmarEstoque = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/confirmar-estoque',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const EnviarSolicitacaoDeConfirmacao = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/enviar-email-para-confirmar-estoque',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const ListaProdutosParaAtualizarEstoque = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/compras/lista-solicitacao-de-estoque',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizarEstoqueProduto = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/compras/atualiza-estoque-produto',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const LayoutPendentes = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/layout/listar-layout-informacoes',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const AtualizaProcessoLayout = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/layout/atualiza-processo-layout',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListaOrcamentoPedido = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/busca/listar-orcamento-pedido',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListaParceiroCadastro = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cliente/parceiro-cadastro',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DeletePedidoFaturamento = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/pedido/deletar-pedido',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const SalvarDadosParceiro = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cliente/salvar-parceiro',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const SalvarDadosContato = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cliente/salvar-contato',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const DeleteContato = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/cliente/delete-contato',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const VerificaNotaExixtente = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/verifica-nota-existente',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListarInformacoesTelaIcms = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/categoria/listar-informacoes-icms',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const ListarInformacoesModalContabilidade = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/listar-informacoes-contabilidade',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const AtualizaUsuarioEmiteNota = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-usuario-emite-nota',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const AtualizaUsuarioDevolucao = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-usuario-devolucao',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const enviarDadosFornecedorDevolucao = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/envia-dados-fornecedor-devolucao',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})
export const atualizaPendenciaDevolucaoEtiqueta = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/site/v2/pedido/atualiza-pendencia-devolucao-etiqueta',
  headers: {
    'Content-type': 'application/json',
    Authorization: token_acesso,
  },
})

export const SalvarDiretorioImagensProdutoURL = process.env.REACT_APP_BASE_URL + '/config-site/salvar-imagens-no-diretorio'
